<!-- @format -->

<div [class.grouping-panel]="!hideGroupingPanel">
  @if (!control && heading) {
    <div role="heading" class="sis-mb-xs sis-label grouping-panel-header" [attr.aria-level]="level">{{ heading | translate }}</div>
  }
  @if (control && heading) {
    <label [class]="'grouping-panel-header ' + labelState">{{ heading | translate }}</label>
  }
  <ng-content select="sis-tiny-badge.header-badge"></ng-content>

  @if (tooltipIcon && !popoverTooltip) {
    <sis-tooltip [tooltipBlockElement]="true" [tooltipClass]="tooltipClass">
      <span class="sis-tooltip-content" [attr.id]="tooltipId" aria-hidden="true">{{ tooltipText | translate }}</span>
      <span class="sis-tooltip-trigger-content icons-wrapper" tabindex="0" [attr.aria-describedby]="tooltipId" role="tooltip">
        <sis-icon [icon]="tooltipIcon" [color]="tooltipIconColor"></sis-icon>
      </span>
    </sis-tooltip>
  }

  @if (tooltipIcon && popoverTooltip) {
    <sis-popover popoverClass="dark">
      <button type="button" class="non-button sis-popover-trigger-content" [attr.aria-label]="'ARIA_LABEL.SHOW_DETAILS' | translate">
        <sis-icon [icon]="tooltipIcon" [color]="tooltipIconColor" aria-hidden="true"></sis-icon>
      </button>
      <span class="sis-popover-popover-content" [attr.id]="tooltipId">{{ tooltipText | translate }}</span>
    </sis-popover>
  }

  <ng-content select="[basic-grouping-panel=headerButton]"></ng-content>

  @if (guidance) {
    <p class="guidance">{{ guidance | translate }}</p>
  }
  <div class="grouping-panel-content">
    <ng-content></ng-content>
  </div>
</div>
